// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { credentials } from "./accounts/credentials";

// Initialize Firebase
const app = initializeApp(credentials);

export const auth = getAuth(app);
export const functionsApp = getFunctions(app);
export const firestore = getFirestore(app);
// connectFunctionsEmulator(functionsApp, "127.0.0.1", 5001); 
